import { useState } from "react";

import TabButton from "../../../../../Components/common/TabButton/TabButton";
import ProcessTree from "../ProcessTree/ProcessTree";
import ReportSearch from "../ReportSearch/ReportSearch";

import "./styles.scss";

const ReportExplorer = ({ id, report }) => {
  const [active, setActive] = useState("Process Tree");

  return (
    <div style={{ position: "relative" }}>
      <div className="button-block">
        <TabButton title="Process Tree" onClick={setActive} active={active} />
        <TabButton title="Report Search" onClick={setActive} active={active} />
      </div>
      <div className="thunter-report-explorer border">
        {active === "Process Tree" ? <ProcessTree id={id} /> : <ReportSearch report={report} />}
      </div>
    </div>
  );
};

export default ReportExplorer;
